export default {
    login: {
        t01: 'Language',
        t02: 'Netflix',
        t03: 'Please enter your username',
        t04: 'Please enter your password',
        t05: 'Login',
        t06: 'Register',
        t07: 'Please enter your phone number',
        t08: 'Confirm Password',
        t09: 'Please enter the invitation code',
        t10: 'Register Account',
        t11: 'Please confirm your password',
        t13: 'A love for films can help you quietly accumulate considerable wealth before you even realize it.',
        t14: 'Login Successful',
        t15: 'Passwords do not match',
        t16: 'Registration Successful',
        t17: 'Network Error',
        t18: 'Request timed out, please check your network connection'
    },
    cover_info: {
        t01: 'Start Earning',
        t02: 'Recharge Coins',
        t03: 'Withdraw Coins',
        t04: 'Certificates'
    },
    cont: {
        t01: 'Choose Language',
        t02: 'All',
        t03: 'Pending',
        t04: 'Completed',
        t05: 'Frozen',
        t06: 'My Balance',
        t07: 'Incomplete',
        t08: 'Total Orders',
        t09: 'Commission',
        t10: 'Earned Commission',
        t11: 'Number of Orders',
        t12: 'Available Balance',
        t13: 'Start Grabbing Orders',
        t14: 'Account Funds',
        t15: 'Submit Order',
        t16: 'All Orders Submitted',
        t17: 'Order Time',
        t18: 'Order Number',
        t19: 'Total Order Amount',
        t21: 'Work',
        t22: 'Actor',
        t23: 'Work comments',
        t24: 'Cancel',
        t25: 'Please Choose Rating',
        t26: 'Order Submission Completed',
        t27: 'Acquired Order',
        t28: 'Grabbing Success',
        t29: 'Failed to Grab Order, Please Try Again Later!'
    }
    ,
    user: {
        t1: 'Referral Code',
        t2: 'Balance',
        t3: 'Available Balance',
        t4: 'Total Earnings',
        t5: 'Withdraw',
        t6: 'Deposit History',
        t7: 'Withdrawal History',
        t8: 'Account Details',
        t9: 'Message',
        t10: 'Connect Bank Card',
        t11: 'Change Password',
        t12: 'Change Withdrawal Password',
        t13: 'Invite Friends',
        t14: 'Choose Language',
        t15: 'Log Out',
        t16: 'Withdraw',
        t17: 'Amount to Withdraw',
        t18: 'Account Name',
        t19: 'Phone Number',
        t20: 'Amount to Withdraw',
        t21: 'Withdraw',
        t22: 'Enter the amount to withdraw',
        t23: 'Enter your virtual funds password',
        t24: 'Total Deposited',
        t25: 'System Messages',
        t26: 'Bank Card Details',
        t27: 'Bank List',
        t28: 'Bank Name',
        t29: 'Alias',
        t30: 'Bank Card Number',
        t31: 'Phone Number',
        t32: 'Confirm Changes',
        t33: 'Enter your connected bank card account number and IFSC code. Please ensure that you enter your name and phone number correctly, as the deposited amount will not be received if this is not done.',
        t34: 'Previous Password',
        t35: 'New Password',
        t36: 'Confirm Password',
        t37: 'Continue',
        t38: 'Remember your password. If you have forgotten your password, please contact customer service.',
        t39: 'Copy Invitation Link',
        t40: 'Invite friends to earn more benefits',
        t41: 'Deposit',
        t42: 'Confirm',
        t43: 'Cancel',
        t44: 'Are you sure you want to log out?',
        t45: 'Amount Deposited',
        t46: 'The deposit was made successfully',
        t47: 'Verification Completed',
        t48: 'Awaiting Verification',
        t49: 'Total Withdrawn',
        t50: 'Please set your withdrawal password first',
        t51: 'Enter your previous password',
        t52: 'Enter your new password',
        t53: 'Confirm Password',
        t54: 'The passwords entered do not match',
        t55: 'Copied',
        t56: 'The withdrawal amount cannot be less than 30',
        t57: 'Successfully sent, redirecting',
        t58: 'Review failed',
        t59: 'Set Avatar',
        t60: 'Set Now',
        t61: 'Setting Successful',
        t62: 'After the wallet approval is passed, you need to log in to withdraw money',
        t63: 'Withdrawal to bank card',
        t64: 'Withdrawal to USDT (ratio 1:0.013)',
        t65: 'Bank Account Number',
        t66: 'Please enter your bank account number and the IFSC code for the bank card you wish to bind, as well as your full name and mobile phone number. Ensure that all information is accurate to facilitate smooth payment transactions.',
        t67: 'Please bind your bank card first',
        t68: 'User recharge',
        t69: 'User accepting orders',
        t70: 'Subordinate commission',
        t71: 'User withdrawal',
        t72: 'Transfer into Yebao',
        t73: 'Transfer out of Yebao',
        t74: 'Yebao earnings',
        t75: 'Order commission',
        t76: 'Balance is below 30, unable to continue trading, please contact customer service',
        t77: 'Please enter the bank name',
        t78: 'Please enter the bank account number',
        t80: 'Please enter your full name',
        t81: 'Please enter your phone number',
        t82: 'Please enter the withdrawal amount',
        t83: 'Copy',
        t84: 'Daily Top 100: Global',
        t85: 'Listen',
        t86: "Email",
        t87: "Please enter your email",
        t88: "Bank Code",
        t89: "Please enter the bank code",
        t90: 'Bank transfer',
        t91: '1. Nenhuma taxa é exigida para saques',
        t92: '2. A retirada será recebida com sucesso dentro de 10 a 15 minutos após a retirada. Para saques após o horário comercial, o recebimento será feito no próximo horário comercial.'
    },
    movie: {
        t01: 'Popular movies and TV shows',
        t02: 'Funds password',
        t03: 'Order discrepancy',
        t04: 'On-chain address management',
        t05: 'Please enter',
        t06: 'Please enter the correct on-chain address and the corresponding network (e.g., ERC20/TRC20/BTC); otherwise, payment/transfer may not arrive or may result in asset loss.',
        t07: 'Withdraw to an on-chain address',
        t08: 'Please add',
        t09: 'Please add an on-chain address',
    },
    langType: '英语'
}
